import script from "./impression.vue?vue&type=script&setup=true&lang=js"
export * from "./impression.vue?vue&type=script&setup=true&lang=js"

import "./impression.vue?vue&type=style&index=0&id=4f91f75c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f91f75c"]])

export default __exports__